import {
  DetailedHTMLProps,
  InputHTMLAttributes,
  JSX,
  useEffect,
  useRef,
} from 'react';
import clsx from 'clsx';

type HtmlInputProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

interface OtpSingleInputProps {
  focus: boolean;
  disabled?: HtmlInputProps['disabled'];
  onBlur?: HtmlInputProps['onBlur'];
  onChange: HtmlInputProps['onChange'];
  onFocus?: HtmlInputProps['onFocus'];
  onKeyDown?: HtmlInputProps['onKeyDown'];
  onPaste?: HtmlInputProps['onPaste'];
  value: string;
}

function OtpSingleInput({
  focus,
  disabled,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  onPaste,
  value,
}: OtpSingleInputProps): JSX.Element {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const isFilled = !!value;

  useEffect(() => {
    if (focus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [focus]);

  return (
    <div className="min-w-0">
      <input
        className={clsx(
          'w-full border-b-2 bg-transparent py-3 text-center text-heading2 text-white outline-none focus:border-blue-primary',
          {
            'border-blue-primary': isFilled,
            'border-grey-50': !isFilled,
          }
        )}
        disabled={disabled}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        ref={inputRef}
        type="number"
        value={value}
      />
    </div>
  );
}

export default OtpSingleInput;
